<div class="bpx-dialog bpx-dialog--wide report-items-import-dialog">
  <h2 mat-dialog-title>Import Report Items</h2>

  <mat-dialog-content>
    <p class="report-items-import-dialog__source">
      <strong>{{ data.fileName }}</strong> &middot; sheet {{ data.sheetName }}
    </p>

    @if (applyCount) {
      <div class="bpx-detail bpx-detail--compact report-items-import-dialog__counts">
        <div class="bpx-detail__item">
          <span class="bpx-detail__label">Rows Updated</span>
          <span class="bpx-detail__value">{{ data.updateCount }}</span>
        </div>
        <div class="bpx-detail__item">
          <span class="bpx-detail__label">Rows Added</span>
          <span class="bpx-detail__value">{{ data.addCount }}</span>
        </div>
      </div>
      <p class="report-items-import-dialog__caption">
        Rows already in the table that the sheet does not name are left unchanged. Nothing is saved
        to the study until Update Study is used.
      </p>
    } @else {
      <div class="bpx-error report-items-import-dialog__none">
        <mat-icon fontIcon="error_outline"></mat-icon>
        <span>No rows in this sheet can be imported.</span>
      </div>
    }

    @if (data.incompleteCount) {
      <p class="report-items-import-dialog__caption">
        {{ data.incompleteCount }} {{ data.incompleteCount === 1 ? 'row was' : 'rows were' }} skipped
        for missing a Kit Lot, Instrument ID or Assay Name.
      </p>
    }

    @if (data.skippedRows.length) {
      <h3 class="bpx-section__title report-items-import-dialog__section-title">Skipped Rows</h3>
      <table class="bpx-grid-card report-items-import-dialog__table">
        <thead>
          <tr>
            <th scope="col">Sheet Row</th>
            <th scope="col">Reason</th>
          </tr>
        </thead>
        <tbody>
          @for (row of visibleSkippedRows; track row.sheetRow) {
            <tr>
              <td>{{ row.sheetRow }}</td>
              <td>{{ row.reason }}</td>
            </tr>
          }
        </tbody>
      </table>
      @if (hiddenSkippedCount) {
        <p class="report-items-import-dialog__caption">
          and {{ hiddenSkippedCount }} more.
        </p>
      }
    }

    @if (data.ignoredHeaders.length) {
      <h3 class="bpx-section__title report-items-import-dialog__section-title">Ignored Columns</h3>
      <div class="bpx-tags">
        @for (header of data.ignoredHeaders; track header) {
          <span class="bpx-tag">{{ header }}</span>
        }
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    <button matRipple class="bpx-btn bpx-btn--primary" [disabled]="!applyCount" (click)="confirm()">
      Import
    </button>
    <button matRipple class="bpx-btn" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
